export const FLEETRIFYROUTEPATH = {
  LOGIN: "/login",
  VERIFY_EMAIL: "/verify-email",
  FORGOT_PASSWORD: "/forgot-password",
  DASHBOARD: "/dashboard",
  COMPANY: "/company",
  COMPANY_DETAILS: "/company-details",
  COMPANY_BRANCHES: "/company-branches",
  ANALYSIS: "/analysis",
  USER: "/user",
  BRANCH: "/branch",
  VIDEO_GUIDE: "/video-guide",
  ORDERS: "/orders",
  VIEW_ORDER: "/orders/view-order/:orderId",
  VIEW_SERVICE: "/services/view-service/:serviceId",
  ORDER_DETAILS: "/orders/order-details",
  WALLET: "/wallet",
  WALLET_SETUP: "/wallet/wallet-setup",

  MESSAGE: "/message",
  REPORT: "/report",
  AUDIT_LOG: "/audit-log",
  SERVICES: "/services",

  SETTINGS: "/settings",
  SUBSCRIPTION: "/settings?tab=subscription",
  HOMEPAGE: "/homepage",
  ONBOARDINGINDIVIDUALKYCFORM: "/onboarding-individual-kycform",
  ONBOARDINGCOMPANYKYCFORM: "/onboarding-company-kycform",

  SIGN_UP: "/sign-up",
  CREATE_ACCOUNT: "/create-account",
  PASSWORD_VERIFICATION: "/password-verification",
  PASSWORD_RESET: "/password-reset",

  ACCEPT_INVITE: "/accept-invite",
  REJECT_INVITE: "/reject-invite",

  STAFF_ACCEPT_INVITE: "/staff/accept-invite",
  STAFF_REJECT_INVITE: "/staff/reject-invite",

  COMPANYSETUP: "/companysetup",
  COMPANYPROFILE: "/companyprofile",
  COMPANYPROFILESETUP: "/companyprofilesetup",

  INDIVIDUALPROFILE: "/individualprofile",
  INDIVIDUALSETUP: "/individualsetup",
  INDIVIDUALPROFILESETUP: "/individualprofilesetup",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  FLEET_MANAGEMENT: "/fleet-management",
  ORDER_REQUESTS: "/order-requests",
  INSIGHTS: "/insights",
  RELOCATION_QUOTES: "/relocation-quotes",
  CONTACT_SUPPORT: "/contact-support",
};
